import './AccordionActiveContainer.css';
import { User } from '../../../../components/Header/elements/User/User';
import pistol from '../../../../images/pistol.png';
import { Border } from '../../../../components/Border/Border';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { Final } from '../../../Classic/Final/Final';
import { SliderClassic } from '../../../Classic/components/SliderClassic/SliderClassic';

export const AccordionActiveContainer = ({ setIsInventoryOpen }: { setIsInventoryOpen: Dispatch<SetStateAction<boolean>> }) => {
    const [gameRooms, setGameRooms] = useState('');
    const [choiceSkin, isChoiceSkin] = useState(true);
    const [timer, isTimer] = useState(false);
    const [game, isGame] = useState(false);
    const [final, isFinal] = useState(false);

    function getLayout() {
        if (choiceSkin) {
            isChoiceSkin(false);
            isTimer(true);
        }
        if (timer) {
            isTimer(false);
            isGame(true);
        }
        if (game) {
            isGame(false);
            isFinal(true);
        }
    }

    return (
        <>
            {final ? (
                <Final />
            ) : (
                <div className="accordion-container">
                    {game ? (
                        <SliderClassic />
                    ) : (
                        <div className="accordion-container__container-wait">
                            {timer ? (
                                <span
                                    onClick={getLayout}
                                    className="accordion-container__container-wait-text accordion-container__container-wait-text_time"
                                >
                                    осталось секунд
                                </span>
                            ) : (
                                <span className="accordion-container__container-wait-text">Ожидаем ставки всех участников баттла</span>
                            )}
                            {timer ? (
                                <span className="accordion-container__container-wait-text-timer">00:09</span>
                            ) : (
                                <button onClick={getLayout} className="accordion-container__container-wait-button">
                                    {' '}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                        <g fill="none" opacity=".6">
                                            <circle cx="11.92" cy="11.92" r="10" />
                                            <path
                                                fill="#F1F1F1"
                                                d="M16.92 10.92h-3a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a1 1 0 0 1-1 1h-3a1 1 0 0 0 0 2h3a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2z"
                                            />
                                        </g>
                                    </svg>
                                    войти в комнату
                                </button>
                            )}
                            <div className="accordion-container__container-wait-background-count"></div>
                        </div>
                    )}

                    <div onClick={getLayout} className="accordion-container__container-skins">
                        <User />
                        <div className="accordion-container__skins">
                            <img src={pistol} alt="" />
                            <img src={pistol} alt="" />
                            <img src={pistol} alt="" />
                        </div>
                        <div className="accordion-container__count-container">
                            <span className="accordion-container__count-money">5256.00 р.</span>
                            <span className="accordion-container__count-skins">3 скина</span>
                        </div>
                    </div>
                    <Border />
                    <div className="accordion-container__container-skins">
                        <User />
                        <div className="accordion-container__skins">
                            <img src={pistol} alt="" />
                            <img src={pistol} alt="" />
                            <img src={pistol} alt="" />
                        </div>
                        <div className="accordion-container__count-container">
                            <span className="accordion-container__count-money">5256.00 р.</span>
                            <span className="accordion-container__count-skins">3 скина</span>
                        </div>
                    </div>
                    <Border />
                    <div className="accordion-container__container-skins">
                        <User />
                        <div className="accordion-container__skins">
                            <img src={pistol} alt="" />
                            <img src={pistol} alt="" />
                            <img src={pistol} alt="" />
                        </div>
                        <div className="accordion-container__count-container">
                            <span className="accordion-container__count-money">5256.00 р.</span>
                            <span className="accordion-container__count-skins">3 скина</span>
                        </div>
                    </div>
                    <Border />

                    <div className="accordion-container__footer-container">
                        <div className="accordion-container__game-container">
                            <span className="accordion-container__footer-text">Игра # 18583610</span>
                        </div>
                        <div className="accordion-container__hash-container">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                                <g fill="none" opacity=".6">
                                    <path
                                        fill="#605F68"
                                        d="M14.545 5.263c.038-.674-.435-1.292-1.1-1.402-2.768-.455-2.556-2.581-5.532-2.581S5.15 3.406 2.383 3.861c-.666.11-1.139.728-1.1 1.402.284 5.086 2.32 7.503 6.63 9.35 4.311-1.847 6.346-4.264 6.632-9.35z"
                                    />
                                    <path
                                        fill="#F1F1F1"
                                        d="M7.247 10.613a.665.665 0 0 1-.472-.195l-2-2a.666.666 0 1 1 .943-.943l1.529 1.529 2.862-2.862a.666.666 0 1 1 .942.943l-3.333 3.333c-.13.13-.3.195-.471.195z"
                                    />
                                </g>
                            </svg>
                            <span className="accordion-container__footer-text">
                                {' '}
                                ХЕШ B61C5BFA521BD637289EB33B00B8E5331315EA2171092D9E0FDA46E05881DD7C
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
